import { render, staticRenderFns } from "./cashBoxesTable.vue?vue&type=template&id=5b761e99&"
import script from "./cashBoxesTable.vue?vue&type=script&lang=ts&"
export * from "./cashBoxesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports